<template>
  <div>
    <v-app-bar
      dense
      flat
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="4"
          md="3"
          class="d-none d-sm-flex"
        >
          <v-text-field
            id="gallery_search"
            v-model.trim="searchText"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            clearable
            outlined
            hide-details
            dense
            @input="search()"
          />
        </v-col>
        <v-col
          xs="12"
          sm="8"
          md="9"
          align="end"
        >
          <v-btn
            id="gallery_refresh"
            color="primary"
            :loading="loader"
            class="mr-1 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                id="image_add"
                slot="activator"
                :disabled="!$store.getters.checkUserPrivilege('ACC_GALLERY')"
                small
                class="elevation-0"
                color="success"
                @click="uploadImage()"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon> Image
              </v-btn>
            </template>
            <span>Upload Images.</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <v-text-field
              id="gallery_search--1"
              v-model.trim="searchText"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              clearable
              outlined
              hide-details
              dense
              @input="search()"
            />
          </v-col>
        </v-row>
        <v-row
          v-show="totalPage == 0"
          class="py-4 px-1"
        >
          no images found
        </v-row>
        <v-row
          v-show="totalPage != 0"
          class="py-4 px-1"
        >
          <v-col
            v-for="image in images"
            :key="image.id"
            class="d-flex child-flex"
            cols="12"
            sm="4"
            md="3"
            lg="2"
          >
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card>
                  <v-card-text class="pa-0">
                    <v-img
                      :src="`${image.imgUrl}?v=${image.version}`"
                      aspect-ratio="1"
                      contain
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          />
                        </v-row>
                      </template>
                    </v-img>
                  </v-card-text>
                  <v-card-actions v-if="image.tags !== ''">
                    <div class="caption">
                      {{ image.tags }}
                    </div>
                    <v-spacer />
                  </v-card-actions>
                  <v-fade-transition>
                    <v-overlay
                      v-if="hover"
                      absolute
                    >
                      <v-row
                        align="center"
                        justify="center"
                      >
                        <v-col cols="auto">
                          <v-btn
                            color="primary"
                            @click="edit(image)"
                          >
                            Edit
                            <v-icon small>
                              mdi-pencil-outline
                            </v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn
                            color="primary"
                            @click="deleteImage(image)"
                          >
                            Delete
                            <v-icon small>
                              mdi-delete-outline
                            </v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn
                            color="primary"
                            @click="addTags(image)"
                          >
                            <v-icon small>
                              mdi-plus
                            </v-icon>
                            Tags
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </template>
            </v-hover>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              @input="getImages()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
      <fileUpload
        :show.sync="uploadFile"
        @fetchImages="reload"
      />
      <TagEdit
        :show-edit-tag.sync="showEditTagDialog"
        :tag-info="tagInfo"
        @updateTag="updateTags"
      />
      <ImageEdit
        :show-edit-image.sync="showEditImage"
        :selected-image="currentImg"
        @editImage="updateImage"
      />
    </v-card>
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import FileUpload from "./Upload.vue";
import TagEdit from "./EditTag.vue";
import ImageEdit from "./ImageEdit.vue";

export default {
  name: "Gallery",
  components: {
    FileUpload,
    TagEdit,
    ImageEdit
  },
  mixins: [failure, pagination],
  data() {
    return {
      loader: false,
      totalPage: 0,
      page: 1,
      searchText: "",
      images: [],
      //baseURL: `${this.IMAGE_SERVER_API_URL}/api/v2`,
      uploadFile: false,
      showEditImage: false,
      showEditTagDialog: false,
      tagInfo: {},
      currentImg: {}
    };
  },
  created() {
  console.log("IMAGE_SERVER_API_URL =", this.IMAGE_SERVER_API_URL);
  console.log("accountId =", this.$route.params.accountId);
  this.getImages();
},
  methods: {
    uploadImage() {
      this.uploadFile = true;
    },
    getImages() {
      this.loader = true;
      let accountId = this.$route.params.accountId;
      let url = `${this.ADMIN_API_URL}/accounts/${accountId}/images?page=${
        this.page - 1
      }&sort_key=tags&limit=${this.limit}`;
      if (this.searchText) {
        url += `&search=${this.searchText}`;
      }

      this.$http.get(url).then(
        (res) => {
          console.log("API response:", res.body);
          this.images = res.body.data || [];
          this.totalPage = res.body.totalPage;
          this.page = res.body.pagination.page + 1;
          this.loader = false;
        },
        (failure) => {
          this.handleFailure(failure);
          this.loader = false;
        }
      );
    },
    edit(image) {
      this.showEditImage = true;
      this.currentImg = image;
    },
    deleteImage(image) {
      this.$root.$confirm
        .open("Confirm", "Are you sure want to remove the image ?", {
          color: "red"
        })
        .then((confirm) => {
          if (confirm) {
            let accountId = this.$route.params.accountId;
            let url = `${this.ADMIN_API_URL}/accounts/${accountId}/images/${image.id}`;
            this.$http.delete(url).then(
              (resp) => {
                this.getImages();
                console.log("Image delete Successfully", resp);
              },
              (failure) => {
                console.log("Delete image for IMAGE ID failed", failure);
              }
            );
          }
        });
    },
    updateTags(updatedTag) {
      // console.log(updatedTag);
      let accountId = this.$route.params.accountId;
      let url = `${this.ADMIN_API_URL}/accounts/${accountId}/images/${updatedTag.refID}/updateTags?tags=${updatedTag.tags}`;
      this.$http.put(url).then(
        (resp) => {
          console.log("Success RESPONSE", resp);
          console.log("Update tag for IMAGE ID ", updatedTag.refID);
          this.getImages();
        },
        (failure) => {
          console.log("Update tag for IMAGE ID failed", failure);
        }
      );
    },
    updateImage(imageInfo) {
      let accountId = this.$route.params.accountId;
      let url = `${this.ADMIN_API_URL}/accounts/${accountId}/images/${imageInfo.id}`;
      let formData = new FormData();
      formData.set("image", imageInfo.file);
      this.$http.put(url, formData).then(
        (resp) => {
          console.log("Image update success!", { resp });
          this.getImages();
        },
        (failure) => {
          console.log("Update IMAGE failed", failure);
        }
      );
    },
    addTags(imageInfo) {
      console.log({ imageInfo });
      this.showEditTagDialog = true;
      this.tagInfo = imageInfo;
    },
    search() {
      if (this.searchText && this.searchText.length < 3) {
        return;
      }
      this.page = 1;
      this.getImages();
    },
    reload() {
      this.searchText = null;
      this.search();
    }
  }
};
</script>
